import { render, staticRenderFns } from "./InventoryMPQRForm.vue?vue&type=template&id=3b33323a&scoped=true&"
import script from "./InventoryMPQRForm.vue?vue&type=script&lang=js&"
export * from "./InventoryMPQRForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryMPQRForm.vue?vue&type=style&index=0&id=3b33323a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33323a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VChip,VCol,VContainer,VRow,VTextField})
